import React, {useEffect, useMemo, useRef, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {Spin} from "antd";
import {setError, setHideFooter, updateCurrStep} from "../../../../../../redux/stepperSlice";
import {t} from "../../../../../../services/i18n";
import {callManageLog, getMessageToUserFromError, updatePaymentProcessInDB} from "../../../../../../services/Helpers";
import {useToast} from "react-native-toast-notifications";
import {paymentLogs} from "../../../../../../services/ConstHelper";
import {hideLoader, showLoader} from "../../../../../../redux/rootManagerSlice";
import {toggleScheduleLoader} from "../../../../../../redux/ScheduleSlice";

const Payment = (props) => {
    const { values, setFieldValue, handleSubmit, cartOverride, membership_user_id, locationOverride } = props;
    const user = useSelector((state) => state.stepper.props?.user);
    const error = useSelector((state) => state.stepper.error);
    const box = useSelector(state => state.box.box)
    const lang = useSelector(state => state.userSettings.lang);
    const token = useSelector(state => state.auth?.data?.token);
    const flowConfig = useSelector(state => state.stepper)
    const [submitted, setSubmitted] = useState(false);
    const [iframeSrc, setIframeSrc] = useState(null);
    const [loading, setLoading] = useState(true);
    const [gotInitMessage, setGotInitMessage] = useState(null);
    const [communicationError, setCommunicationError] = useState(false);
    const [externalExecute, setExternalExecute] = useState(false);

    const dispatch = useDispatch()
    const toast = useToast();
    const gotInitMessageRef = useRef(gotInitMessage);

    const boxLang = useMemo(() => lang?.language === 'Hebrew' ? 'he' : 'en', [lang])
    const cart = useMemo(() => cartOverride ?? values.cart ?? [], [cartOverride, values.cart])
    const locationId = useMemo(() => locationOverride ?? (cart.length ? cart[0].location_box_fk : null), [cart, locationOverride])
    const hideBack = useMemo(() => flowConfig.steps.length === 1, [flowConfig.steps])

    useEffect(() => {
        dispatch(setHideFooter(true))
        const listenToMessages = (event) => {
            if(event.data?.data?.uuidPayment === gotInitMessageRef.current?.uuidPayment) {
                if (event.data.type === "PAYMENT_RESPONSE_SUCCESS") {
                    setTimeout(() => {
                        setExternalExecute(true)
                        callManageLog(paymentLogs.successResponseLog, event.data.data)
                        setFieldValue('payment_info', event.data.data)
                    }, 10)
                }
                if (event.data.type === "EXECUTION_RESPONSE_SUCCESS") {
                    setTimeout(() => {
                        callManageLog(paymentLogs.executionSuccessLog, event.data.data)
                        if (event.data.data?.payment_info) setFieldValue('payment_info', event.data.data.payment_info)
                        setFieldValue('res', event.data.data.response ?? true)
                    }, 10)
                }
                if (event.data.type === "PAYMENT_MANAGE_BACK") {
                    const stepIndex = flowConfig.steps.indexOf(flowConfig?.currStep);
                    dispatch(updateCurrStep(flowConfig.steps[stepIndex - 1]))
                }
                if (event.data.type === "PAYMENT_RESPONSE_ERROR") {
                    console.log('error!!!! ', event.data)
                    callManageLog(paymentLogs.errorResponseLog, event.data)
                    dispatch(setError({messageToUser: t('payment-generic-error'), message: 'payment-error'}))
                    dispatch(hideLoader())
                    dispatch(toggleScheduleLoader(false));
                }
                if (event.data.type === 'STARTED_EXECUTION') {
                    dispatch(showLoader())
                    dispatch(toggleScheduleLoader(true));
                    callManageLog(paymentLogs.startedExecutionLog, event.data.data)
                    if (event.data.data?.payment_info) setFieldValue('payment_info', event.data.data?.payment_info)
                }
            }
            if(event.data.type === "PAYMENT_LISTENER_CHECK") {
                const data = event.data.data
                if(!gotInitMessageRef.current && data?.uuidPayment && data?.paymentProcessToken) {
                    setGotInitMessage(data)
                    updatePaymentProcessInDB({uuid: data.uuidPayment, paymentProcessToken: data.paymentProcessToken, values})
                    setFieldValue('uuidPayment', data.uuidPayment)
                    callManageLog(paymentLogs.gotInitMessageLog, {})
                }
            }
        }

        const timeoutId = waitForInitMessage()
        window.addEventListener('message', listenToMessages);
        return () => {
            callManageLog(paymentLogs.stopListeningResponseLog, {})
            window.removeEventListener("message", listenToMessages);
            clearTimeout(timeoutId)
            setSubmitted(false)
            dispatch(setHideFooter(false))
        };
    }, []);

    useEffect(() => {
        if(locationId && boxLang && (cart.length || membership_user_id)) {
            const iframe = getIframeSrc()
            setIframeSrc(iframe)
        }
    }, [locationId, boxLang, user, cart, membership_user_id]);

    //TODO: THIS IS A BIG ISSUE FOR SERVER MOVE! MISSING IN VALUES AT TIME OF ENDPOINT LOG, I NEED TO FIX THIS
    // moved it to "getRequestReadyValues"
    // useEffect(() => {
    //     setFieldValue('user', user ?? null)
    // }, [user]);

    //flows that was not executed by payment process (like flowType=document etc.)
    useEffect(() => {
        if(values.payment_info && !submitted && externalExecute) {
            callManageLog(paymentLogs.submitLog, values)
            handleSubmit()
            setSubmitted(true)
        }
    }, [values.payment_info, submitted, externalExecute]);

    //flows that was already executed by payment process (all normal flows, no flowType)
    useEffect(() => {
        if(values.res && !submitted) {
            console.log('omg submitting!!', values)
            handlePaymentSubmit()
        }
    }, [values.res, submitted]);

    useEffect(() => {
        if(error && error !== '') {
            console.log('error',error)
            setFieldValue('payment_info', null)
            setFieldValue('res', null)
            setIframeSrc(null)
            setSubmitted(false)
            setGotInitMessage(null)
            setExternalExecute(false)
            callManageLog(paymentLogs.errorResponseLog, {error, values})
            const errorMessage = getMessageToUserFromError(error)
            toast.show(errorMessage !== '' ? errorMessage : t('payment-error'), { type: 'danger', duration: 5000 });
            setTimeout(() => setIframeSrc(getIframeSrc()), 10)
            dispatch(setError(null))
        }
    }, [error]);

    useEffect(() => {
        gotInitMessageRef.current = gotInitMessage;
    }, [gotInitMessage]);

    useEffect(() => {
        callManageLog(paymentLogs.iframeLog, {iframeSrc, values})
    }, [iframeSrc]);

    const waitForInitMessage = () => {
        const timeoutId = setTimeout(() => {
            //if gotInitMessage is null after 10 seconds, stop payment process completely
            if(!gotInitMessageRef.current) {
                callManageLog(paymentLogs.noInitMessageLog, {})
                setFieldValue('payment_info', null)
                setIframeSrc(null)
                setSubmitted(false)
                toast.show(t('payment-communication-error'), { type: 'danger', duration: 5000 });
                setCommunicationError(true)
            }
        }, 10000)
        return timeoutId
    }

    const handlePaymentSubmit = () => {
        setSubmitted(true)
        callManageLog(paymentLogs.submitLog, values)
        handleSubmit()
    }

    // name and phone are only for meshulam
    const getUserName = () => {
        const firstName = user?.first_name ?? values?.first_name ?? values?.child?.first_name
        const lastName = user?.last_name ?? values?.last_name ?? values?.child?.last_name
        if(firstName) {
            if(firstName.length >= 2) {
                return `&name=${firstName} ${lastName || ''}`
            }
        }

        return ''
    }

    const getUserPhone = () => {
        const phone = user?.phone ?? values?.phone
        if(phone && (phone[0] === '0' || phone.startsWith('972')) && phone.length >= 10) {
            return `&phone=${phone}`
        }
        return ''
    }

    const getStartDates = () => {
        if(cart.some(item => item.start)) {
            const cartWithDates = cart.reduce((acc, item) => (item.start ? {[item.id]: item.start} : acc), {})
            return Object.keys(cartWithDates).length ? `&startDates=${JSON.stringify(cartWithDates)}` : ''
        }
        return ''
    }

    const getIframeSrc = () => {
        return `${process.env.REACT_APP_PAYMENTS_URL}?box_id=${box.id}&lang=${boxLang}&locations_box_id=${locationId}&userId=${user?.user_fk ?? null}&cart=${JSON.stringify(cart.map(item => item.id))}&staffToken=${token}&membershipUserId=${membership_user_id ?? null}&hideBack=${hideBack}${getUserName()}${getUserPhone()}${getStartDates()}`
    }

    if(communicationError) return null

    return (
        <div style={{display: 'flex', flexDirection: 'column', flex: 1}}>
            <Spin spinning={loading} style={{alignSelf: 'center', justifyContent:'center', flex: 1}}/>
            {iframeSrc &&
                <iframe frameBorder={0}
                        style={{width: '100%', flex: 1}}
                        onLoad={() => setLoading(false)}
                        src={iframeSrc}/>}
        </div>
    );
};

export default Payment;